
// Mutations
export const BINDPLAYERPROPS = 'BINDPLAYERPROPS'
export const UNBINDPLAYERPROPS = 'UNBINDPLAYERPROPS'

export const RESETPLAYERPROPS = 'RESETPLAYERPROPS'

// Actions
export const ADDPLAYERPROP = 'ADDPLAYERPROP';
export const DELETEPLAYERPROP = 'DELETEPLAYERPROP';
export const TOGGLEPLAYERPROP = 'TOGGLEPLAYERPROP';


import db from '../../firebase/firebase'
import {
  bindArrayBase,
  removeBoundFromObject,
  updateBoundInObject } from '../helpers/binding';
import { snapshots2objects } from '../helpers/general'

export default {
  state: () => ({
    playerprops: {},
  }),

  getters: {
    playerSuppliesProperty: ( state ) => ( playerid, propKey ) => {
      if( !state.playerprops[ playerid ] ) return false
      return state.playerprops[ playerid ][ propKey ]
    },
  },

  mutations: {
    addBoundPlayerPropBatch: ( state, arrayOfSnapshots ) => {
      const arrayOfObjects = snapshots2objects( arrayOfSnapshots )
      state.playerprops = mergeWith( arrayOfObjects, state.playerprops )
    },
    removeBoundPlayerProp: ( state, { snapshot } ) => removeBoundFromObject( state.playerprops, snapshot ),
    updateBoundPlayerProp: ( state, { snapshot } ) => updateBoundInObject( state.playerprops, snapshot ),

    [RESETPLAYERPROPS] ( state ) {
      state.playerprops = {}
    },
  },

  actions: {
    async [BINDPLAYERPROPS] ( { commit }, guild ) {
      const ref = db.ref( 'guildPlayerProperties/' + guild['.key'] )
      return bindArrayBase( ref, commit, 'PlayerProp', true, false, false, null )
    },
    [UNBINDPLAYERPROPS] ( { rootState } ) {
      let guild = rootState.guilds.selectedGuild
      if( guild ) {
        db.ref( 'guildPlayerProperties/' + guild['.key'] ).off()
      }
    },
    
    [ADDPLAYERPROP] ( context, { guild, playerid, property } ) {
      if( guild && playerid && property && !property.ischarspecific ) {
        db.ref( 'guildPlayerProperties/' + guild['.key']
                + '/' + playerid + '/' + property['.key'] ).set( true )
      }
    },
    [DELETEPLAYERPROP] ( context, { guild, playerid, property } ) {
      if( guild && playerid && property && !property.ischarspecific ) {
        db.ref( 'guildPlayerProperties/' + guild['.key'] +
          '/' + playerid + '/' + property['.key']).remove()
      }
    },
    [TOGGLEPLAYERPROP] ( { getters, dispatch }, { guild, playerid, property } ) {
      if( guild && playerid && property && !property.ischarspecific ) {
        if( getters.playerSuppliesProperty( playerid, property['.key'] ) ) {
          dispatch( DELETEPLAYERPROP, { guild, playerid, property } )
        }
        else {
          dispatch( ADDPLAYERPROP, { guild, playerid, property } )
        }
      }
    },

  },
}

function mergeWith( arrayOfObjects, playerprops ) {

  let newplayerprops = { ...playerprops }

  for( let playerPropObj of arrayOfObjects ) {

    let playerid = playerPropObj['.key']
    newplayerprops[ playerid ] = {... playerPropObj}

  }

  return newplayerprops
}
